/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export const getMessageText = (meta, text, newLine) => {
  let message = ''
  if ((meta.visited || meta.touched) && meta.error) {
    meta.error.forEach(({ path }, index) => {
      message += text(path)
      if (meta.error.length !== index + 1) {
        if (newLine) {
          message += '\n'
        } else {
          message += ', '
        }
      }
    })
  }
  return message
}

export const isErrorShown = meta => {
  if (meta.touched) {
    return !!meta.error
  }
  return false
}

export const getFieldState = meta => {
  let state = 'default'
  if (meta.touched) {
    state = meta.error ? 'warning' : 'valid'
  }
  return state
}

export const isErrorIncludes = ({ error = [] }, errorText) => {
  return !!error.find(({ path }) => path.includes(errorText))
}
